import React from 'react';
import classes from './Logout.module.css';
import strings from '../../assets/localization';
import Button from '../UI/Button/Button';
import LogoutAdItem from './LogoutAdItem/LogoutAdItem';
import Logo from '../UI/Logo/Logo';

const Logout = (props) => {
  const logotype = props.isLandscape ? <Logo style={{background: 'none'}} /> : <Logo style={{background: 'none', width: '9rem', height: '2rem'}} />;
  let adsList = null;
  adsList = props.ads.length > 0 && props.ads.map((ad, i) => {
    return <LogoutAdItem key={'ad' + i} ad={ad} onAdClick={() => { props.onAdClick(ad); }} />;
  });
  return (
    <div className={classes.LogoutWrapper}>
      <div className={classes.LogoutLogo}>
        {logotype}
      </div>
      <div className={classes.LogoutInner}>
        <div className={classes.LogoutH1}>{strings.LogoutH1}</div>
        <div className={classes.LogoutP}>{strings.LogoutP}</div>
        <div className={classes.LogoutAdList}>
          {adsList}
        </div>
        <div className={classes.buttonWrapper}>
          <Button style={{width: '80%'}} clicked={props.goToIndex}>{strings.LogoutButton}</Button>
        </div>
      </div>
    </div>
  );
};

export default Logout;
